import { Component, OnInit, Input } from '@angular/core';
import { DynamicGridComponent } from '../../dynamic-entity/dynamic-entity.module';
import { ApiService, MetadataService, ExpressionFilter, ExpressionRule, Operator, Condition } from '../../ubi-core/ubi-core.module';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UbiFilterService } from '../../theme/index';
import { ToastrService } from 'ngx-toastr';
import { isDate } from '@swimlane/ngx-charts/release/utils';
import { saveAs } from 'file-saver';

declare var $: any;

@Component({
  selector: 'app-customer-reports',
  templateUrl: './customer-reports-detail.component.html',
  styleUrls: ['./customer-reports.component.scss']
})

export class CustomerReportsDetailComponent extends DynamicGridComponent implements OnInit {
  @Input()
  hasCustomerFilter: boolean;
    
  private customers = [];
  private vessels = [];
  private customerId = null;
  private vesselAndProcessId = null;
  private soldToId = null;
  private shipToId = null;
  private startDate: string = null;
  private endDate: string = null;
  private timestamp: number;
  private method = 'DetailedVesselUnloadMovements';

  constructor(protected baseservice: ApiService, protected metadataservice: MetadataService,
    protected router: Router, protected route: ActivatedRoute, protected modalService: NgbModal,
    protected filterservice: UbiFilterService, protected toastr: ToastrService) {
    super(baseservice, metadataservice, router, route, modalService, filterservice);
  }

  ngOnInit() {
    this.vesselAndProcessId = +this.route.snapshot.params['vesselAndProcessId'];
    this.timestamp = +this.route.snapshot.params['timestamp'];
    this.soldToId = +this.route.snapshot.params['soldToId'];
    this.shipToId = +this.route.snapshot.params['shipToId'];

    if (!isNaN(this.timestamp)) {
      this.startDate = this.getTodayDateString(new Date(this.timestamp));
      this.endDate = this.getTodayDateString(new Date(this.timestamp));
    }

    super.ngOnInit();

    const hasCustomerFilterFromRoute = this.route.snapshot.data['hasCustomerFilter'];

    if (hasCustomerFilterFromRoute != null && this.hasCustomerFilter == null) {
      this.hasCustomerFilter = hasCustomerFilterFromRoute;
    }

    if (this.hasCustomerFilter) {
      this.customerId = +this.route.snapshot.params['customerId'];
      this.getCustomers();

      if (this.customerId != null && !isNaN(this.customerId)){
        this.getVessels();
      }
    } else {
      this.getVessels();
    }

    if (this.vesselAndProcessId !== null && this.vesselAndProcessId !== undefined && !isNaN(this.vesselAndProcessId)) {
      this.view();
    }
  }

  /**
   * Get data on onInit
   * This is an override
   */
  protected getInitialData() {
    // if (this.vesselAndProcessId !== null && this.vesselAndProcessId !== undefined && !isNaN(this.vesselAndProcessId)) {
    //   this.view();
    // }
  }

  /**
   * Export entity to Excel format
   * This is an override
   */
  public excel() {

    this.baseservice.exportExcel({ offset: 0, pageSize: 100 }, this.filter, 'ExportDetailedToExcel')
      .subscribe(return_value => {
        saveAs(return_value.blob, return_value.filename);
      },
      error => { console.log('Error exporting Excel ' + this.entity + ' ' + error); }
      );
  }

  onCustomerChange(event) {
    this.vesselAndProcessId = null;
    this.vessels = [];

    if (this.customerId === '') {
      this.customerId = null;
    } else {
      this.getVessels();
    }
  }

  onVesselChange(event) {
    if (this.vesselAndProcessId === '') {
      this.vesselAndProcessId = null;
    }
  }

  getPage(pageInfo, filter, method = null) {

    this.filter = this.setFilter();

    super.getPage(pageInfo, this.filter, this.method);
  }

  /**
   * 
   */
  public view() {
    if (this.hasCustomerFilter && (this.customerId == null || isNaN(this.customerId))){
      this.toastr.warning('Deve seleccionar um cliente', '', { timeOut: 4000 });
    } else {
      this.filter = this.setFilter();

      this.getPage({ offset: 0 }, this.filter, this.method);
    }
  }

  private setFilter() {
    this.baseservice.setEntity(this.entity);
    let mapFilter = new ExpressionFilter(Condition.AND);

    if (this.hasCustomerFilter && this.customerId !== null && this.customerId !== undefined && !isNaN(this.customerId)) {
      mapFilter.addRule(new ExpressionRule('CustomerId', Operator.Equal, this.customerId));
    }

    if (this.vesselAndProcessId !== null && this.vesselAndProcessId !== undefined && !isNaN(this.vesselAndProcessId)) {
      mapFilter.addRule(new ExpressionRule('VesselAndProcessId', Operator.Equal, this.vesselAndProcessId));
    }

    if (this.startDate !== null && this.startDate !== undefined && this.startDate != '') {
      mapFilter.addRule(new ExpressionRule('OutputDate', Operator.Greater_or_Equal, new Date(this.startDate)));
    }

    if (this.endDate !== null && this.endDate !== undefined && this.endDate != '') {
      const endDateWithTime = new Date(this.endDate);
      endDateWithTime.setDate(new Date(this.endDate).getDate() + 1);
      mapFilter.addRule(new ExpressionRule('OutputDate', Operator.Less, endDateWithTime ));
    }

    if (this.soldToId !== null && this.soldToId !== undefined && !isNaN(this.soldToId)) {
      mapFilter.addRule(new ExpressionRule('SoldToID', Operator.Less_or_Equal, this.soldToId));
    }

    if (this.shipToId !== null && this.shipToId !== undefined && !isNaN(this.shipToId)) {
      mapFilter.addRule(new ExpressionRule('ShipToID', Operator.Less_or_Equal, this.shipToId));
    }

    return mapFilter;
  }

  private getCustomers() {
    this.baseservice.setEntity('Customers/GetSeaportCustomers');
    this.baseservice.getPage({ 'pageSize': 100, 'sortAsString': 'Designation' }).subscribe(
      response => {
        this.customers = response.data;
      },
      error => {
        console.log('Error getting customers list: ' + error);
        this.toastr.error('Erro a obter a lista de clientes.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity(this.entity);
  }

  /**
   * 
   */
  private getVessels() {
    const url = this.hasCustomerFilter
      ? this.entity + '/VesselAndProcesses?customerId=' + this.customerId
      : this.entity + '/VesselAndProcesses';

    this.baseservice.setEntity(url);
    this.baseservice.getAll().subscribe(
      response => {
        this.vessels = response;
      },
      error => {
        console.log('Error getting vessels list: ' + error);
        this.toastr.error('Erro a obter a lista de navios.', '', { timeOut: 3000 });
      });
    this.baseservice.setEntity(this.entity);
  }

  /**
   * 
   */
  private getTodayDateString(date) {
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
    return date.getFullYear() + '-' + month + '-' + day;
  }

  private exportTruckLoadMovements(item) {

    const reportRequest = {
      'Path': 'TruckLoadMovements',
      'Parameters': {
        'ReportNumber': item.ReportNumber,
        'Version': 1
      }
    };
    this.requestReport(reportRequest, 'TruckLoadMovements.pdf', 'PDF');

  }

  private requestReport(request: object, fileName: string, format: string) {
    //this.processing = true;
    this.baseservice.setEntity('Reports/ExportTo' + format);
    this.baseservice.getFile(request, 'application/pdf').subscribe(
      response => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response);
        link.download = fileName;
        link.click();
        //this.processing = false;
      },
      error => {
        console.log('Error getting report: ' + error);
        this.toastr.error('Erro a gerar o relatório.', '', { timeOut: 3000 });
        //this.processing = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/customerReports/customer-reports-detail.component.ts